var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchByUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.591 15.4404H16.5145L16.133 15.0725C17.7681 13.165 18.6129 10.5625 18.1496 7.79647C17.5092 4.00855 14.3481 0.983667 10.5329 0.520396C4.76927 -0.188135 -0.0814453 4.66258 0.627086 10.4262C1.09036 14.2414 4.11524 17.4025 7.90316 18.0429C10.6692 18.5062 13.2716 17.6614 15.1792 16.0263L15.5471 16.4078V17.4843L21.338 23.2751C21.8966 23.8338 22.8096 23.8338 23.3682 23.2751C23.9269 22.7165 23.9269 21.8036 23.3682 21.2449L17.591 15.4404ZM9.4156 15.4404C6.02282 15.4404 3.28408 12.7017 3.28408 9.30891C3.28408 5.91613 6.02282 3.17739 9.4156 3.17739C12.8084 3.17739 15.5471 5.91613 15.5471 9.30891C15.5471 12.7017 12.8084 15.4404 9.4156 15.4404Z",
    fill: "#B6B6B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchByUser);
export default __webpack_public_path__ + "static/media/searchByUser.d6641f224c727f9e9b5bb18f319a72a4.svg";
export { ForwardRef as ReactComponent };